import { Link } from "react-router-dom";
import { PRODUKT, SLOGAN } from "../lib/config";

// Loggan: två lika långa streck, debet = kredit. Det nedre är turkost, agentens färg.
// Samma figur ligger i public/favicon.svg.
export function LoggaMarke({ storlek = 34 }: { storlek?: number }) {
  return (
    <svg className="mark" viewBox="0 0 32 32" width={storlek} height={storlek} aria-hidden="true" focusable="false">
      <rect width="32" height="32" rx="9" fill="#3346A8" />
      <rect x="8" y="10" width="16" height="4.4" rx="2.2" fill="#fff" />
      <rect x="8" y="17.6" width="16" height="4.4" rx="2.2" fill="#5DD3DE" />
    </svg>
  );
}

// Ordbilden: "Balance" i textfärg och "IQ" i turkos.
export function Ordbild() {
  const iq = PRODUKT.endsWith("IQ");
  return <span className="namn">{iq ? <>{PRODUKT.slice(0, -2)}<span className="iq">IQ</span></> : PRODUKT}</span>;
}

// Märket med ordbild. Underraden är sloganen, eller tom.
export function Marke({ under = SLOGAN }: { under?: string }) {
  return (
    <Link to="/" className="brand" aria-label={`${PRODUKT}, till startsidan`}>
      <LoggaMarke />
      <Ordbild />
      {under ? <span className="sub">{under}</span> : null}
    </Link>
  );
}
